export { default } from './FailedBotMessageContent';
